import { lt } from '@mews/framework';
import { WithEnterpriseId, WithOwnerId } from '@mews-commander/types';
import { ContentCard, SuspenseBoundary, TooltippedIcon } from '@mews-commander/ui';
import { Banner, IconName, Stack } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';
import { canCurrentProfileViewCompanyData } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { useCommanderSelector } from '@mews-commander/utils';
import { useDashboardBills } from '../hooks';
import { HeaderActions } from '../../../../../customerDetail/components/tables/BillsTable/HeaderActions';
import { BillTableNew } from './BillTableNew';

export const BillsContainer = ({ ownerId, enterpriseId }: WithOwnerId & WithEnterpriseId) => {
    const { bills, isLoading } = useDashboardBills({ ownerId, enterpriseId });
    const hasViewDataPermission = useCommanderSelector(canCurrentProfileViewCompanyData);
    const numberOfBills = bills ? bills.length : 0;

    return (
        <ContentCard
            data-test-content-card="bills-table"
            title={lt('OwnedBills')}
            description={
                <Stack>
                    {lt('BillPlural')}
                    {UnicodeEntity.Colon}
                    {UnicodeEntity.NoBreakSpace}
                    {hasViewDataPermission ? numberOfBills : UnicodeEntity.Dash}
                    <>
                        {UnicodeEntity.NoBreakSpace}
                        <TooltippedIcon
                            size="small"
                            value={IconName.Info}
                            tooltip={TextKey.DashboardOwnedBillsTooltip}
                        />
                    </>
                </Stack>
            }
            actions={
                <SuspenseBoundary loader="inline">
                    <HeaderActions accountId={ownerId} />
                </SuspenseBoundary>
            }
        >
            {hasViewDataPermission ? (
                <>
                    <BillTableNew bills={bills || []} billOwnerId={ownerId} isLoading={isLoading} />
                </>
            ) : (
                <Banner centered variant="warning" primaryText={lt('NoPrivilegeViewCompanyData')} />
            )}
        </ContentCard>
    );
};
